import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface SearchIconStyles {
    searchIcon?: InjectableCss;
}

export const searchIconStyles: SearchIconStyles = {
    searchIcon: {
        css: css`
            display: flex;
            & path {
                fill: none;
                stroke: #000;
                stroke-linecap: round;
                stroke-linejoin: round;
                stroke-width: 1.5px;
            }
        `,
    },
};

const styles = searchIconStyles;

const SearchIcon: React.FC = () => {
    return (
        <StyledWrapper {...styles.searchIcon}>
            <svg xmlns="http://www.w3.org/2000/svg" width="18.812" height="18.811" viewBox="0 0 18.812 18.811">
                <g transform="translate(-57.749 -4683.75)">
                    <g transform="translate(58.499 4684.5)">
                        <path
                            d="M19.822,12.16A7.661,7.661,0,1,1,12.161,4.5a7.661,7.661,0,0,1,7.661,7.66Z"
                            transform="translate(-4.5 -4.5)"
                        />
                        <path d="M28.627,28.627l-3.652-3.652" transform="translate(-11.626 -11.627)" />
                    </g>
                </g>
            </svg>
        </StyledWrapper>
    );
};

export default React.memo(SearchIcon);
